import TextHighlighter from "../TextHighlighter";
import m, {Vnode} from "mithril";
import TextHighlighterComponent from "../TextHighlighterComponent/TextHighlighterComponent";
import ICustomFormSettings from "../../ICustomFormSettings";


export default class TextHighlighterComment extends TextHighlighter {

    private highlighter: TextHighlighterComponent;

    constructor(settings: ICustomFormSettings) {
        super(settings);
        this.highlighter = new TextHighlighterComponent(this.text, this.textareaItemPositive, this.textareaItemNegative);
    }

    view(): Vnode {
        return this.viewLayout(
            m(this.highlighter)
        );
    }

    oninit() {
        this.settings.app.header.hint = this.settings.form.hint || this.settings.form.questionary.messages.get('textHighlighterHint');
    }

    onremove() {
        this.settings.app.header.hint = null;
    }

}